import { render, staticRenderFns } from "./ChangeGroup.vue?vue&type=template&id=0ac733f8&scoped=true"
import script from "./ChangeGroup.vue?vue&type=script&lang=js"
export * from "./ChangeGroup.vue?vue&type=script&lang=js"
import style0 from "./ChangeGroup.vue?vue&type=style&index=0&id=0ac733f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac733f8",
  null
  
)

export default component.exports